export default __webpack_public_path__ + "static/media/CV_BODY.38becd54.pdf";